import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../Common/LoadingSpinner";
import AboutHero from "./AboutHero";
import AboutStory from "./AboutStory";
import AboutMission from "./AboutMission";
import AboutFeatures from "./AboutFeatures";
import AboutCraftsmanship from "./AboutCraftsmanship";

function About() {
  const [aboutData, setAboutData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const res = await fetch(`${(process.env.REACT_APP_API_URL || 'http://localhost:5000').trim()}/about`);
        const data = await res.json();
        setAboutData(data.abouts[0]); // Assuming you want the first object
      } catch (error) {
        console.error("Error fetching about data:", error);
        // Fallback data for debugging
        setAboutData({
          title: "About HIRAPANNA",
          subtitle: "Jewellery of Distinction",
          Image1: "/About1.png",
          Image2: "/About2.png",
          description1: "Welcome to our jewellery brand.",
          description2: "We offer the finest gold, diamond, and silver pieces.",
          description3: "Our journey began in Muzaffarpur...",
        });
      }
    };

    fetchAboutData();
  }, []);

  if (!aboutData) {
    return <LoadingSpinner />;
  }

  return (
    <main className="min-h-screen bg-white">
      <AboutHero />
      <AboutStory />
      <AboutMission />
      <AboutFeatures />
      <AboutCraftsmanship />
    </main>
  );
}

export default About;